import * as yup from 'yup';
import { Row, RenderConfig, TextInput, AssetUploadInput, ASSET_TYPE } from 'commons-ui';

const FORM_FIELD_KEYS = {
	REASON: 'reason',
	ATTACHMENTS: 'attachments',
	FRESHDESK_ID: 'freshdeskTicketId'
};

export const validationSchema = yup.object().shape({
	reason: yup
		.string()
		.matches(/^[0-9a-zA-Z.,\s]{0,100}$/, 'Reason should only contains alphanumeric characters or space or , or .')
		.required('Reason is a required field'),
	freshdeskTicketId: yup.string().required('freshdeskTicketId is a required field, If no ticket exists then please create one')
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.REASON]: new RenderConfig()
		.setName('reason')
		.setLabel('Reason')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.FRESHDESK_ID]: new RenderConfig()
		.setName('freshdeskTicketId')
		.setLabel('Freshdesk Ticket Id')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.ATTACHMENTS]: new RenderConfig()
		.setName('attachments')
		.setLabel('Attachments')
		.setRenderer(AssetUploadInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, assetType: ASSET_TYPE.MEDIA_PRIVATE, multiple: true })
};

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.REASON),
	new Row(FORM_FIELD_KEYS.FRESHDESK_ID),
	new Row(FORM_FIELD_KEYS.ATTACHMENTS)
];
